module.exports = __webpack_public_path__ + "img/icon_coupom_white.d68a0947.svg";